// src/mixins/globalMixin.js
export default {
  computed: {
    isInvestor() {
      return this.$cookie.get('type') === '投资人';
    },
  },
  methods: {
    handlePreviews(id, freezeStatus) {
      if (this.handleStatus(freezeStatus)) {
        return;
      }
      if (this.$cookie.get('type') === '投资人') {
        return;
      }
      this.imageId = id;
      this.isMyUpload = true;
    },
    handleStatus(freezeStatus) {
      if (freezeStatus === 1) {
        this.$message.warning('该订单已冻结，无法操作');
        return true;
      } else {
        return false;
      }
    },
  },
};
